"use client";
import { useEffect, useState } from "react";

import Image from "next/image";
import { useRouter } from "next/navigation";

import { useScreenSize } from "../shared/hooks";

import { Box } from "@/ui/primitives";

const Home = () => {
  const [theme, setTheme] = useState(null);
  const { screenSizeName } = useScreenSize();
  const router = useRouter();

  useEffect(() => {
    const storedTheme = localStorage.getItem("chakra-ui-color-mode") || "light";
    setTheme(storedTheme);

    if (screenSizeName === "mobile") {
      router.push("/lawyer-panel/mobile");
    }
  }, [screenSizeName, router]);

  if (theme === null) {
    return (
      <div
        style={{ width: "100vw", height: "100vh", backgroundColor: "#fff" }}
      />
    );
  }

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {screenSizeName !== "mobile" ? (
        <Image
          src={
            theme === "dark"
              ? "/images/actum-dark.jpg"
              : "/images/actum-white.jpg"
          }
          alt="photo"
          layout="fill"
          objectFit="cover"
          priority
        />
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          position={"relative"}
          w={"100%"}
        >
          <Image
            src={"/images/Actum-Logo.png"}
            alt="photo"
            priority
            width={"40"}
            height={"40"}
          />
          <Box mt="40px" position={"relative"} w={"100px"} height={"50px"}>
            <Image
              src={"/images/Actum-Product-name.jpg"}
              alt="photo"
              fill
              priority
            />
          </Box>
        </Box>
      )}
    </div>
  );
};

export { Home };
